import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Modal, Pressable, StyleSheet, Text, View, FlatList, useWindowDimensions } from 'react-native';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { Image, ImageSource } from 'expo-image';
import {
  ArrowIcon,
  Button,
  Panel,
} from 'react95-native-rabbl';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { CloseIcon } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import { Gallery, IGallery } from "@/components/Gallery";

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: 200,
  },
  centerAndPadding: {
    padding: 15,
    alignItems: 'center',
  },
  windowView: {
    alignItems: 'center',
  },
  horizontal: {
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
    width: '100%',
    alignItems: 'center',
  },
  contentWrapper2: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 5,
    gap: 10,
    width: '100%',
  },
  black: {
    color: '#000000',
  },
  divider1: {
    marginTop: 15,
    marginBottom: 10,
  },
  padding5: {
    padding: 5,
  },
  bold: {
    fontWeight: "bold",
  },
  strikethrough: {
    textDecorationLine: 'line-through',
  },
  empty: {
  },
  panelWithTopMargin: {
    marginTop: 7,
    maxWidth: "85%",
    minWidth: AppConsts.BASIC_MINIMUM_WIDTH,
  },
  panel: {
    padding: 20,
    gap: 20,
  },
  wrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 50,
    justifyContent: 'center',
  },
  buttonWrapper: {
    gap: 16,
  },
  galleryContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  thumb: {
    width: AppConsts.BASIC_MINIMUM_WIDTH,
    height: AppConsts.BASIC_MINIMUM_WIDTH,
    borderRadius: 8,
    overflow: 'hidden',
  },
  thumbImage: {
    width: '100%',
    height: '100%',
  },
  text: {
    textAlign: 'center',
    color: '#222',
    fontSize: 22,
    fontWeight: 'bold',
  },
  noteText: {
    textAlign: 'center',
    color: 'white',
    paddingHorizontal: 24,
  },
  textWrapper: {
    backgroundColor: AppConsts.COLOR2,
    borderWidth: 1,
    alignSelf: 'flex-start',
    alignItems: 'center',
    padding: 10,
    marginLeft: 20,
  },
});

type Props = {
};

const photos = [
  {
    source: require('@/assets/images/screenshots/screenshot1.png'),
    note: 'Potential matches',
    key: "screenshot1",
  },
  {
    source: require('@/assets/images/screenshots/screenshot2.png'),
    note: 'Chat with a match',
    key: "screenshot2",
  },
  {
    source: require('@/assets/images/screenshots/screenshot3.png'),
    note: 'Switch between Rabbls',
    key: "screenshot3",
  },
  {
    source: require('@/assets/images/screenshots/screenshot4.png'),
    note: 'Profile pictures and re-ordering',
    key: "screenshot4",
  },
  {
    source: require('@/assets/images/screenshots/screenshot5.png'),
    note: 'About you which is searchable',
    key: "screenshot5",
  },
  {
    source: require('@/assets/images/screenshots/screenshot6.png'),
    note: 'Filters for age and height',
    key: "screenshot6",
  },
  {
    source: require('@/assets/images/screenshots/screenshot7.png'),
    note: 'Set your current location',
    key: "screenshot7",
  },
  {
    source: require('@/assets/images/screenshots/screenshot8.png'),
    note: 'Preferences',
    key: "screenshot8",
  },
];

export default function Screenshots({ } : Props) {
  const gallery = useRef<IGallery>(null);

  return (
    <>
      <Panel variant='raised' elevation={4} style={styles.panelWithTopMargin}>
        <View style={styles.panel}>
          <View style={AppConstants.STYLES.width100PAlignCenter}>
            <CustomText>Screenshots</CustomText>
          </View>
          <View style={styles.galleryContainer}>
            {photos.map((photo, index) => (
              <Pressable key={photo.key} style={styles.thumb} onPress={() => gallery.current?.open(index)}>
                <Image source={photo.source} style={styles.thumbImage} contentFit="contain" />
              </Pressable>
            ))}
          </View>
        </View>
      </Panel>
      <Gallery items={photos} ref={gallery} />
    </>
  );
}
